import { render, staticRenderFns } from "./RegistersPerPage.vue?vue&type=template&id=7df2aa15&"
import script from "./RegistersPerPage.vue?vue&type=script&lang=js&"
export * from "./RegistersPerPage.vue?vue&type=script&lang=js&"
import style0 from "./RegistersPerPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports